import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M2.03662 7.33333H3.33333C4.06971 7.33333 4.66667 7.93029 4.66667 8.66667V9.33333C4.66667 10.0697 5.26362 10.6667 6 10.6667C6.73638 10.6667 7.33333 11.2636 7.33333 12V13.9634M5.33333 2.62368V3.66667C5.33333 4.58714 6.07953 5.33333 7 5.33333H7.33333C8.06971 5.33333 8.66667 5.93029 8.66667 6.66667C8.66667 7.40305 9.26362 8 10 8C10.7364 8 11.3333 7.40305 11.3333 6.66667C11.3333 5.93029 11.9303 5.33333 12.6667 5.33333L13.3763 5.33333M10 13.6586V12C10 11.2636 10.597 10.6667 11.3333 10.6667H13.3763M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z" />
  </svg>
);
